import Vue from 'vue'

export default {
  methods: {
    ACTIONTEMPLATE (e) {
      var vm = this
      e = JSON.parse(JSON.stringify(e))
      return {
        template: Vue.component('temp', {
          template: `<div>
            <div style='float: left;' v-if='ACTION.cc'>
              <a :href='urlEditar(templateArgs.clienteid)'
                @click.prevent='buttonClickEditar(templateArgs.clienteid)'
                style="width: 40px;" class='btn btn-warning btn-sm' title='Editar Cliente'>
                <i class='fa fa-address-book-o'></i>
              </a>
            </div>
            <div style='float: left;' v-if='ACTION.ca'>
              <a :href='urlEditar(templateArgs.clienteid, "/agenda")'
                @click.prevent='buttonClickEditar(templateArgs.clienteid, "/agenda")'
                style="width: 40px;" class='btn btn-primary btn-sm' title='Nova Agenda'>
                <i class='fa fa-calendar-check-o'></i>
              </a>
            </div>
            <div style='float: left;' v-if='ACTION.cv'>
              <a :href='urlEditar(templateArgs.clienteid, "/vendas")'
                @click.prevent='buttonClickEditar(templateArgs.clienteid, "/vendas")'
                style="width: 40px;" class='btn btn-success btn-sm' title='Nova Venda'>
                <i class='fa fa-cart-plus'></i>
              </a>
            </div>
            <div style='float: left;'>
              <a href='#' @click.prevent='excluirAgenda(templateArgs.agenda_id)'
                style="width: 40px;" class='btn btn-danger btn-sm' title='Excluir'>
                <i class='fa fa-times'></i>
              </a>
            </div>
            </div>`,
          data () {
            return {
              templateArgs: {},
              ACTION: vm.ACTION
            }
          },
          methods: {
            urlEditar (clienteid, pag = '', id = '') {
              return `/sistema/clientes/${clienteid}${pag}${id ? '/' + id : ''}`
            },
            buttonClickEditar (clienteid, pag = '', id = '') {
              vm.$router.push(`/sistema/clientes/${clienteid}${pag}${id ? '/' + id : ''}`)
            },
            excluirAgenda (id) {
              vm.$swal.fire({
                title: 'Excluir este contato?',
                text: 'Esta ação não pode ser desfeita.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim, excluir!'
              }).then((result) => {
                if (result.value) {
                  vm.$axios.delete(`${vm.$url}/agenda/${id}`).then(() => {
                    vm.$swal.fire('Excluído!', 'Contato removido.', 'success')
                    vm.$refs.datasource1.kendoDataSource.read()
                  })
                }
              })
            }
          }
        }),
        templateArgs: e
      }
    }
  }
}
